import React, { useEffect, useRef, useState } from "react";
import { FaBell, FaEnvelope, FaSearch } from "react-icons/fa";
import { IoLogOut } from "react-icons/io5";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import ToastFile from "../utils/ToastFile";
import { Button } from "react-bootstrap";

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 375);
  const [showNotif, setShowNotif] = useState(false);
  const [notifAnim, setNotifAnim] = useState(false);
  const bellRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsSmallMobile(window.innerWidth <= 375);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Animation control
  useEffect(() => {
    if (showNotif) {
      setTimeout(() => setNotifAnim(true), 10); // trigger animation
    } else {
      setNotifAnim(false);
    }
  }, [showNotif]);

  // Close on click outside
  useEffect(() => {
    if (!showNotif) return;
    const handleClick = (e) => {
      if (bellRef.current && !bellRef.current.contains(e.target)) {
        setNotifAnim(false);
        setTimeout(() => setShowNotif(false), 200);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [showNotif]);

  const openNotif = () => {
    setShowNotif(true);
  };

  const closeNotif = () => {
    setNotifAnim(false);
    setTimeout(() => setShowNotif(false), 200);
  };
  useEffect(() => {
    // Initialize Bootstrap tooltip
    const tooltipTrigger = document.getElementById("logout-tooltip");
    if (tooltipTrigger && window.bootstrap) {
      new window.bootstrap.Tooltip(tooltipTrigger);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    ToastFile("Logout successful.", "added");
    navigate("/login");
  };
  return (
    <>
      <nav
        className={`navbar navbar-expand-lg navbar-light bg-white shadow-sm mt-3`}
        style={{
          paddingLeft: isMobile ? "72px" : "24px",
          paddingRight: "10px",
        }}
      >
        <form
          className={`d-flex me-auto`}
          style={{
            width: isSmallMobile ? "200px" : isMobile ? "250px" : "350px",
          }}
        >
          <input
            className="form-control me-2"
            type="search"
            placeholder="Search for..."
            aria-label="Search"
          />
          <button className="btn btn-outline-dark" type="submit">
            <FaSearch />
          </button>
        </form>
        <ul className="navbar-nav align-items-center d-flex flex-row">
          {/* <li
            className="nav-item mx-2 position-relative"
            style={{ cursor: "pointer" }}
            ref={bellRef}
          >
            <span onClick={openNotif}>
              <FaBell size={21} />
              <span className="badge bg-danger position-absolute top-0 start-100 translate-middle badge rounded-pill">
                5<span className="visually-hidden">unread messages</span>
              </span>
            </span>
            {showNotif && (
              <div
                className={`notif-dropdown ${
                  notifAnim ? "notif-open" : "notif-close"
                }`}
                style={{
                  minWidth: isMobile ? 260 : 320,
                  right: isMobile ? 0 : -40,
                  left: isMobile ? 0 : "auto",
                  // transform: isMobile ? "none" : "translateX(-50%)",
                  top: 36,
                  zIndex: 3000,
                }}
              >
                <div className="notif-header d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                  <h6 className="mb-0">Notifications</h6>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={closeNotif}
                  ></button>
                </div>
                <div className="notif-body px-3 py-2">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">New user registered</li>
                    <li className="list-group-item">Server backup completed</li>
                    <li className="list-group-item">New message received</li>
                    <li className="list-group-item">System update available</li>
                    <li className="list-group-item">5 unread notifications</li>
                  </ul>
                </div>
              </div>
            )}
          </li> */}
          <li
            className="nav-item mx-2"
            style={{ cursor: "pointer" }}
            //onClick={logout}
          >
            <Button
              variant="outline-dark"
              size="sm"
              onClick={logout}
              className="logout-button d-none d-md-block"
            >
              Logout <IoLogOut size={25} />
            </Button>
            <Button
              variant="outline-dark"
              size="sm"
              onClick={logout}
              className="logout-button d-md-none"
            >
              <IoLogOut size={25} />
            </Button>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
